import React, { useState, useEffect } from 'react';
import { FaMapMarkerAlt, FaInstagram, FaGlobe, FaPhone, FaUtensils } from 'react-icons/fa';
import { API_BASE } from '../config';
import './BusinessesSection.css';

const BusinessesSection = () => {
  const [businesses, setBusinesses] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE}/businesses`)
      .then(res => res.json())
      .then(data => setBusinesses(data))
      .catch(() => {});
  }, []);

  if (businesses.length === 0) return null;

  return (
    <section className="businesses-section">
      <div className="biz-bg-shape biz-bg-shape--1"></div>
      <div className="biz-bg-shape biz-bg-shape--2"></div>
      <div className="biz-bg-shape biz-bg-shape--3"></div>
      <div className="biz-bg-shape biz-bg-shape--4"></div>
      <div className="biz-bg-shape biz-bg-shape--5"></div>
      <div className="businesses-container">
        <div className="businesses-header">
          <span className="businesses-subtitle">Hizmetlerimiz</span>
          <h2 className="businesses-title">İşletmelerimiz</h2>
          <p className="businesses-desc">
            Didim'de birbirinden farklı alanlarda hizmet veren işletmelerimiz
          </p>
        </div>

        <div className="businesses-grid">
          {businesses.map((biz) => (
            <div className="biz-card" key={biz._id}>
              <div className="biz-card-image">
                <img src={biz.image} alt={biz.name} />
                <div className="biz-card-overlay"></div>
              </div>
              <div className="biz-card-content">
                <h3 className="biz-card-name">{biz.name}</h3>
                <p className="biz-card-desc">{biz.description}</p>
                <div className="biz-card-actions">
                  <div className="biz-card-icons">
                    {biz.location && (
                      <a href={biz.location} className="biz-icon" title="Konum" target="_blank" rel="noreferrer">
                        <FaMapMarkerAlt />
                      </a>
                    )}
                    {biz.phone && (
                      <a href={`tel:${biz.phone}`} className="biz-icon" title="Telefon">
                        <FaPhone />
                      </a>
                    )}
                    {biz.instagram && (
                      <a href={biz.instagram} className="biz-icon" title="Instagram" target="_blank" rel="noreferrer">
                        <FaInstagram />
                      </a>
                    )}
                    {biz.website && (
                      <a href={biz.website} className="biz-icon" title="Web Sitesi" target="_blank" rel="noreferrer">
                        <FaGlobe />
                      </a>
                    )}
                  </div>
                  {biz.isRestaurant && (
                    <a href={`/menu/${biz.slug}`} className="biz-menu-btn">
                      <FaUtensils />
                      <span>Menü</span>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessesSection;
